var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.615,
    height: 84.279,
    viewBox: "0 0 104.615 84.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#3f3d56}.cls-2{fill:#f2f2f2}.cls-5{fill:#6c6c6c}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    transform: "translate(-453 -396.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    transform: "translate(453 396.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6011",
    d: "M166.98 215.1c-.406 0-.817-.006-1.219-.019l.009-.293c.578.018 1.169.023 1.75.015v.293q-.268.004-.54.004zm2.305-.068l-.017-.292c.579-.034 1.166-.082 1.744-.143l.031.291c-.583.057-1.174.106-1.758.14zm-5.285-.05c-.584-.045-1.174-.1-1.755-.175l.036-.291c.576.07 1.161.129 1.741.173zm8.791-.322l-.044-.289c.576-.087 1.156-.189 1.723-.3l.057.287c-.572.112-1.156.214-1.736.302zm-12.29-.107c-.577-.1-1.16-.21-1.731-.334l.062-.286c.567.123 1.145.235 1.718.332zm15.748-.58l-.07-.284c.565-.14 1.133-.294 1.689-.459l.083.281c-.561.166-1.133.321-1.702.462zm-19.193-.168c-.566-.151-1.136-.316-1.693-.492l.088-.279c.553.175 1.118.339 1.68.488zm22.573-.835l-.1-.277c.548-.191 1.1-.4 1.639-.613l.109.272c-.54.219-1.096.427-1.649.619zm-25.939-.229c-.55-.2-1.1-.42-1.644-.648l.114-.27c.537.226 1.086.443 1.631.643zm29.208-1.079l-.121-.267c.527-.239 1.056-.495 1.573-.759l.133.261c-.521.267-1.054.524-1.583.765zm3.133-1.6l-.145-.254c.5-.288 1.009-.591 1.5-.9l.156.247c-.494.31-1.002.615-1.511.906zm2.976-1.883l-.168-.24c.475-.332.95-.68 1.41-1.034l.178.232c-.463.356-.941.706-1.42 1.041zm-44.634-.412c-.473-.343-.945-.7-1.4-1.069l.183-.229c.455.363.924.72 1.393 1.061zm47.427-1.735l-.189-.224c.443-.374.884-.764 1.311-1.158l.2.215c-.431.397-.875.789-1.322 1.166zm-50.184-.466c-.44-.385-.878-.786-1.3-1.192l.2-.211c.419.4.853.8 1.29 1.183zm52.772-1.927l-.208-.206c.409-.414.813-.842 1.2-1.273l.218.2c-.391.429-.798.86-1.21 1.278zm-55.315-.514c-.4-.425-.8-.864-1.186-1.3l.221-.192c.38.438.776.873 1.177 1.295zm57.676-2.106l-.226-.186c.369-.449.732-.913 1.08-1.378l.235.175c-.351.47-.717.935-1.089 1.388zm-59.986-.556c-.363-.458-.72-.931-1.062-1.406l.238-.171c.339.471.694.941 1.054 1.4zm62.1-2.269l-.242-.164c.327-.481.646-.976.951-1.471l.25.153c-.309.497-.632.996-.961 1.481zm-64.156-.59c-.319-.489-.631-.993-.928-1.5l.252-.149c.295.5.6 1 .921 1.485zm66-2.418l-.256-.142c.281-.509.554-1.031.812-1.553l.263.13c-.259.525-.534 1.051-.817 1.564zm1.564-3.166l-.271-.12c.233-.533.457-1.079.666-1.622l.273.1c-.206.554-.431 1.104-.667 1.641zm-70.855-.632c-.225-.539-.439-1.09-.639-1.639l.275-.1c.2.544.411 1.091.634 1.626zm72.122-2.667l-.278-.092c.183-.551.355-1.113.512-1.673l.282.079c-.154.565-.331 1.13-.515 1.685zm-73.325-.642c-.174-.558-.338-1.128-.487-1.695l.283-.074c.147.562.31 1.128.483 1.682zm74.279-2.752l-.285-.066c.131-.564.251-1.141.356-1.713l.288.053c-.105.576-.226 1.156-.358 1.725zm-75.174-.658c-.122-.572-.233-1.155-.328-1.732l.289-.048c.1.573.2 1.152.326 1.719zm75.812-2.809l-.29-.04c.079-.574.145-1.158.2-1.738l.292.026c-.053.585-.12 1.174-.2 1.752zm-76.389-.669c-.069-.58-.126-1.17-.169-1.755l.292-.021c.042.58.1 1.166.167 1.742zm76.707-2.842l-.293-.013c.026-.58.039-1.169.039-1.749h.293c0 .585-.013 1.178-.04 1.762zm-76.965-.674c-.01-.359-.015-.725-.015-1.089q0-.338.006-.675l.293.005q-.006.334-.006.67c0 .36.005.724.015 1.081zm.353-3.507l-.292-.018c.037-.585.087-1.176.15-1.757l.291.032c-.062.576-.112 1.163-.149 1.743zm76.169-1.787c-.058-.577-.139-.859-.224-1.434l.29-.043c.085.579.159 1.021.218 1.6zm-75.793-1.691l-.289-.045c.09-.579.194-1.163.31-1.736l.287.058c-.115.568-.218 1.148-.307 1.722zm75.273-1.467c-.112-.571-.238-1.146-.375-1.709l.285-.069c.138.567.265 1.147.378 1.722zm-74.58-1.962l-.284-.071c.142-.567.3-1.139.468-1.7l.28.084c-.163.557-.319 1.126-.461 1.687zm73.752-1.437c-.163-.558-.342-1.118-.53-1.667l.277-.1c.19.553.37 1.118.535 1.68zm-72.744-1.918l-.276-.1c.195-.554.4-1.11.625-1.653l.272.11c-.216.537-.424 1.094-.617 1.643zm71.607-1.39c-.214-.539-.442-1.08-.68-1.608l.267-.12c.24.532.47 1.077.685 1.62zm-70.292-1.86l-.266-.122c.245-.533.5-1.067.774-1.588l.26.134c-.264.52-.522 1.047-.765 1.576zm68.859-1.323c-.262-.517-.54-1.035-.825-1.54l.255-.144c.288.508.568 1.03.832 1.551zm-67.252-1.791l-.254-.146c.292-.507.6-1.015.916-1.509l.247.158c-.31.49-.616.994-.906 1.497zm65.531-1.25c-.309-.493-.633-.983-.963-1.459l.241-.167c.332.479.659.973.97 1.47zm-63.646-1.7l-.239-.169c.338-.479.691-.956 1.049-1.418l.231.179c-.352.458-.703.931-1.038 1.407zm61.654-1.17c-.353-.462-.72-.922-1.093-1.366l.224-.188c.375.447.745.91 1.1 1.376zm-59.509-1.6l-.223-.19c.379-.445.774-.888 1.174-1.316l.214.2c-.393.427-.785.867-1.161 1.308zm57.262-1.085c-.393-.428-.8-.853-1.213-1.261l.206-.208c.414.412.826.839 1.222 1.271zm-54.875-1.474l-.2-.209c.419-.41.852-.815 1.288-1.2l.2.219c-.44.385-.868.786-1.284 1.193zm52.393-.993c-.431-.391-.876-.777-1.323-1.146l.187-.226c.45.372.9.761 1.333 1.155zm-49.784-1.337l-.185-.227c.453-.369.921-.733 1.391-1.081l.174.235c-.462.349-.926.71-1.376 1.076zm2.809-2.082l-.163-.243c.485-.326.984-.646 1.483-.949l.152.25c-.492.305-.987.622-1.468.945zm2.985-1.816l-.141-.257c.513-.281 1.039-.553 1.563-.809l.129.263c-.516.258-1.038.528-1.547.807zM184 142.36c-.521-.26-1.055-.51-1.587-.745l.118-.268c.536.237 1.074.49 1.6.751zm-32.2-.86l-.116-.269c.536-.232 1.084-.455 1.629-.662l.1.274c-.541.205-1.085.427-1.617.657zm29-.561c-.542-.21-1.1-.411-1.65-.6l.093-.278c.557.187 1.116.389 1.662.6zm-25.733-.679l-.091-.278c.557-.182 1.124-.354 1.688-.51l.078.282c-.564.158-1.127.329-1.679.51zm22.412-.435c-.559-.159-1.128-.307-1.693-.441l.067-.285c.569.134 1.143.284 1.706.444zm-19.041-.5l-.065-.285c.571-.13 1.152-.249 1.727-.353l.052.288c-.576.106-1.152.225-1.718.353zm15.636-.3c-.57-.107-1.151-.2-1.727-.283l.041-.29c.58.081 1.165.177 1.74.285zm-12.194-.319l-.039-.29c.58-.077 1.169-.142 1.752-.193l.025.292c-.581.051-1.166.115-1.742.192zm8.729-.168c-.577-.054-1.164-.1-1.745-.124l.014-.293c.586.028 1.177.071 1.758.125zm-5.244-.136l-.012-.293c.538-.022 1.087-.034 1.631-.034h.133v.293h-.132c-.545.001-1.085.013-1.624.032z",
    className: "cls-1",
    transform: "translate(-118.769 -130.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_251",
    d: "M0 0H16.129V18.791H0z",
    className: "cls-2",
    transform: "translate(10.485 65.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    d: "M155.306 531.142h-22.549v-22.55h22.549zm-22.236-.313h21.923v-21.923H133.07z",
    className: "cls-1",
    transform: "translate(-122.428 -447.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_252",
    d: "M0 0H13.78V0.313H0z",
    className: "cls-1",
    transform: "translate(15.026 68.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_253",
    d: "M0 0H13.78V0.313H0z",
    className: "cls-1",
    transform: "translate(15.026 71.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_254",
    d: "M0 0H13.78V0.313H0z",
    className: "cls-1",
    transform: "translate(15.026 74.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_255",
    d: "M0 0H32.506V16.131H0z",
    className: "cls-2",
    transform: "translate(32.915 3.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    d: "M325.251 108.121h-39.242V88.5h39.242zm-38.949-.293h38.656V88.793H286.3z",
    className: "cls-1",
    transform: "translate(-253.241 -88.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_256",
    d: "M0 0H21.076V0.293H0z",
    className: "cls-1",
    transform: "translate(38.63 8.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_257",
    d: "M0 0H21.076V0.293H0z",
    className: "cls-1",
    transform: "translate(38.63 11.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_258",
    d: "M0 0H21.076V0.293H0z",
    className: "cls-1",
    transform: "translate(38.63 14.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_259",
    d: "M0 0H13.91V14.789H0z",
    className: "cls-2",
    transform: "translate(77.6 44.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6025",
    d: "M608.75 388.933h-17.571v-17.571h17.571zm-17.278-.293h16.985v-16.985h-16.986z",
    className: "cls-1",
    transform: "translate(-513.725 -329.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_260",
    d: "M0 0H9.664V0.293H0z",
    className: "cls-1",
    transform: "translate(79.723 49.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_261",
    d: "M0 0H9.664V0.293H0z",
    className: "cls-1",
    transform: "translate(79.723 51.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_262",
    d: "M0 0H9.664V0.293H0z",
    className: "cls-1",
    transform: "translate(79.723 53.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_263",
    d: "M0 0H66.996V0.293H0z",
    className: "cls-1",
    transform: "translate(18.892 19.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_264",
    d: "M0 0H36.753V0.293H0z",
    className: "cls-1",
    transform: "translate(67.862 58.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_265",
    d: "M0 0H43.207V0.293H0z",
    className: "cls-1",
    transform: "translate(0 83.881)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(490 408.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6026",
    fill: "#eb5945",
    d: "M24.9 39.717L14.663 21.549a2.383 2.383 0 0 0-4.125 0L.3 39.717a2.4 2.4 0 0 0 2.063 3.57h20.392a2.422 2.422 0 0 0 2.145-3.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6027",
    fill: "#fff",
    d: "M52.647 63.025l10.234 18.168H42.413l10.234-18.168z",
    transform: "translate(-40.047 -40.286)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    transform: "translate(10.928 29.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6028",
    d: "M195.911 180.13l.635 4.2a1.032 1.032 0 0 0 1.031.873 1.1 1.1 0 0 0 1.031-.873l.635-4.2a1.65 1.65 0 0 0-1.666-1.9 1.692 1.692 0 0 0-1.666 1.9z",
    className: "cls-5",
    transform: "translate(-195.905 -178.226)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    cx: 0.952,
    cy: 0.952,
    r: 0.952,
    className: "cls-5",
    transform: "translate(.72 7.854)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataGeneric);
export default __webpack_public_path__ + "static/media/no-data-generic.fa6e6f5d0e24605f8d993da05c8f76bd.svg";
export { ForwardRef as ReactComponent };